export default "/images/order_empty_icon.svg?e3f106965e9b579d812c583125de587e";